// Credit for base64 encode & decoder goes to MDN:
// https://developer.mozilla.org/en-US/docs/Web/API/btoa

/**
 * Encodes given unicode (multibyte) string to base64.
 */
export const base64EncodeMultibyte = (unicode: string) => {
  const codeUnits = Uint16Array.from(
    { length: unicode.length },
    (element: string, index) => unicode.charCodeAt(index),
  );
  const charCodes = new Uint8Array(codeUnits.buffer);

  let result = '';

  charCodes.forEach(char => {
    result += String.fromCharCode(char);
  });

  return global.btoa(result);
};

/**
 * Decodes a base64 string to a unicode (multibyte) string.
 */
export const base64DecodeMultibyte = (base64: string) => {
  const binary = global.atob(base64);

  const bytes = Uint8Array.from(
    { length: binary.length },
    (element: string, index) => binary.charCodeAt(index),
  );
  const charCodes = new Uint16Array(bytes.buffer);

  let result = '';
  charCodes.forEach(char => {
    result += String.fromCharCode(char);
  });

  return result;
};

/**
 * Encodes given string to base64.
 */
export const base64Encode = (unicode: string) => {
  if (typeof window !== 'undefined') {
    return window.btoa(unicode);
  }

  return Buffer.from(unicode).toString('base64');
};

/**
 * Decodes a base64 string to a string.
 */
export const base64Decode = (base64: string) => {
  if (typeof window !== 'undefined') {
    return window.atob(base64);
  }

  return Buffer.from(base64, 'base64').toString();
};
